// Shared perf-log flag: coarse render/compile timings logged to the console.
// Persisted in localStorage so it survives reloads; toggled from the
// Settings panel (Debug → Perf log) or manually via
// localStorage.setItem('fluveria.perfLog', '1').

const PERF_LOG_STORAGE_KEY = 'fluveria.perfLog';

export function isPerfLogEnabled(): boolean {
  try {
    return localStorage.getItem(PERF_LOG_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setPerfLogEnabled(enabled: boolean): void {
  try {
    if (enabled) {
      localStorage.setItem(PERF_LOG_STORAGE_KEY, '1');
    } else {
      localStorage.removeItem(PERF_LOG_STORAGE_KEY);
    }
  } catch {
    // Storage unavailable (private mode etc.) — the toggle is best-effort.
  }
}
